import type { LuggageTypeEntry, SpecialLuggageBaseValues } from '../engine/types'
import { DECIMAL_INPUT_PATTERN } from '@/scopes/common/components/FormElements/utils/decimalPatternUtils'

export interface BikeValues extends SpecialLuggageBaseValues {
  height: string
  width: string
  length: string
  weight: string
  packageType: string
  termsAndConditions: boolean
}

interface BikeEntryLinks {
  termsAndConditions?: string
}

export function createBikeEntry({ links }: { links?: BikeEntryLinks } = {}): LuggageTypeEntry<BikeValues> {
  const { termsAndConditions = '' } = links ?? {}

  return {
    schema: {
      defaultValues: {
        height: '',
        width: '',
        length: '',
        weight: '',
        packageType: '',
        termsAndConditions: false,
      },
      sections: [
        {
          id: 'measureHelpText',
          fields: [
            {
              kind: 'paragraph',
              messageKey: 'booking_details_special_luggage_measure_help_text',
            },
          ],
        },
        {
          id: 'dimensionsRow1',
          layout: 'row',
          fields: [
            {
              kind: 'text',
              name: 'width',
              labelKey: 'booking_details_special_luggage_width_label',
              required: true,
              requiredErrorKey: 'booking_details_special_luggage_dimensions_required_error',
              pattern: DECIMAL_INPUT_PATTERN,
              patternErrorKey: 'booking_details_special_luggage_numeric_pattern_error',
            },
            {
              kind: 'text',
              name: 'height',
              labelKey: 'booking_details_special_luggage_height_label',
              required: true,
              requiredErrorKey: 'booking_details_special_luggage_dimensions_required_error',
              pattern: DECIMAL_INPUT_PATTERN,
              patternErrorKey: 'booking_details_special_luggage_numeric_pattern_error',
            },
          ],
        },
        {
          id: 'dimensionsRow2',
          layout: 'row',
          fields: [
            {
              kind: 'text',
              name: 'length',
              labelKey: 'booking_details_special_luggage_length_label',
              required: true,
              requiredErrorKey: 'booking_details_special_luggage_dimensions_required_error',
              pattern: DECIMAL_INPUT_PATTERN,
              patternErrorKey: 'booking_details_special_luggage_numeric_pattern_error',
            },
            {
              kind: 'text',
              name: 'weight',
              labelKey: 'booking_details_special_luggage_weight_label',
              required: true,
              requiredErrorKey: 'booking_details_special_luggage_dimensions_required_error',
              pattern: DECIMAL_INPUT_PATTERN,
              patternErrorKey: 'booking_details_special_luggage_numeric_pattern_error',
            },
          ],
        },
        {
          id: 'packageType',
          fields: [
            {
              kind: 'dropdown',
              name: 'packageType',
              labelKey: 'booking_details_special_luggage_package_type_label',
              required: true,
              requiredErrorKey: 'booking_details_special_luggage_package_type_required_error',
              options: [
                { value: 'Bike Box', labelKey: 'booking_details_special_luggage_package_type_bike_box' },
                { value: 'Bike Cover', labelKey: 'booking_details_special_luggage_package_type_bike_cover' },
                { value: 'Bike Suitcase', labelKey: 'booking_details_special_luggage_package_type_bike_suitcase' },
              ],
            },
          ],
        },
        {
          id: 'termsAndConditions',
          fields: [
            {
              kind: 'checkbox',
              name: 'termsAndConditions',
              labelKey: 'booking_details_special_luggage_terms_and_conditions_label',
              validationMessageKey: 'booking_details_special_luggage_terms_and_conditions_required_error',
              links: {
                termsAndConditionsLink: {
                  labelKey: 'booking_details_special_luggage_terms_and_conditions_link_label',
                  href: termsAndConditions,
                },
              },
            },
          ],
        },
      ],
    },
  }
}
